<template>
<v-container>
    <div class="home text-center">
       <h1>No Access</h1>
    </div>
</v-container>
</template>
<script>
import globalvar from '../global/globalvar';
export default {
  name: "Newpage",
  mounted() {
        window.localStorage.clear();
        window.location.href=globalvar.PARAM_GLOBAL_LOGIN;
    },
};
</script>